// extracted by mini-css-extract-plugin
export default {"popper":"ThreePoints_popper__nJGzQ","destructive":"ThreePoints_destructive__ah1nG"};